export default "__VITE_ASSET__li4agqHC__"